import React from 'react'
import { Outlet } from 'react-router-dom';
function MainPage() {
  return (
    <div className='w-full h-full'>
    <Outlet/>
</div>
  )
}

export default MainPage